module.exports = __webpack_public_path__ + "static/media/capreit.473fddd8.png";